require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-glennsl-bs-revamp.json") })
        }
      }, "path---package-glennsl-bs-revamp");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-glennsl-bs-revamp!./.cache/json/package-glennsl-bs-revamp.json
// module id = 865
// module chunks = 231608221292675